<template>
	<div class="col-xl-3">
		<div class="card">
			<div class="card-body"
				v-if="!activeEvaluacion"
			>
			
				<h5 class="header-title mb-12">
					{{jsonCurso.idCurso}}.-{{ jsonCurso.tituloCurso }}
				</h5>
        <label> Nota Mínima: {{jsonCurso.notaMinima}}</label>
        <br>
        <label> Nota Máxima: {{jsonCurso.notaMaxima}}</label>
        <br>
        <label> Nota Aprobación Curso: {{jsonCurso.notaAprobacion}}</label>
				<ul class="list-group list-group-flush">
					<li class="list-group-item">
						<div class="media-body">
							<h5 class="header-title mb-4">Evaluaciones</h5>
							<!---->
							<ul
								id="example-2"
								v-for="(ev, key) in jsonEvaluacion"
								:key="key"
							>
								<li>{{ ev.nombreEvaluacion }}</li>
								<p class="text-muted mb-2">
									Fecha Inicio:
									{{
										ev.fechaHabilitacion === null
											? "-"
											: fechaFinal(ev.fechaHabilitacion)
									}}
								</p>
								<p class="text-muted mb-2">
									Fecha Termino:
									{{
										ev.fechaCierre === null
											? "-"
											: fechaFinal(ev.fechaCierre)
									}}
								</p>
								<p class="text-muted mb-2">
									Ponderación:
									{{
										ev.ponderacion === null
											? "-"
											: exigenciaValor(ev.ponderacion)
									}}
								</p>
							</ul>
						</div>
					</li>
				</ul>
			</div>
			<PuSkeleton v-if="activeEvaluacion" :count="6" ></PuSkeleton>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
	computed: {
		...mapState("curso", ["jsonCurso"]),
		...mapState("evaluacion", ["jsonEvaluacion"]),
		...mapState('evaluacion',['activeEvaluacion']),
	},
	methods: {
		fechaFinal(fechaCurso) {
			//Formato fecha es año-mes-dia
			var objDate = new Date(fechaCurso);

			const dia = objDate.toLocaleDateString("es-ES", { day: "numeric" }),
				mes = objDate.toLocaleDateString("es-ES", { month: "long" }),
				año = objDate.toLocaleDateString("es-ES", { year: "numeric" });

			return dia + " " + mes + " " + año;
		},
		exigenciaValor(valor) {
			if (valor) {
				return valor * 100 + "%";
			} else {
				return "-";
			}
		},
	},
};
</script>
